export const statusSeverity = {
  pending: 'warning',
  processing: 'primary',
  shipped: 'secondary',
  finished: 'success',
  cancelled: 'danger',
} as const;

export const statusLatin = {
  pending: 'izchakvane',
  processing: 'obrabotvane',
  shipped: 'izpratena',
  finished: 'zavurshena',
  cancelled: 'otmenena',
} as const;
